//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import entries from '~/config/changelog'
import me from '~/data/me'

export default {
    layout: 'default',
    middleware: [],

    data(){ return {
        entries,
        ...me,
    }},

    metaInfo(){ return {
        title: 'About me and myself',
        link: [
            { rel: 'canonical', href: window.location.href }
        ],
        meta: this.$rm.getMeta(this), // this.$route.meta,
    }},

    mounted(){
        // console.log(this)
    },

    computed: {
        layout () {
            return this.$q.screen.lt.sm ? 'dense' : (this.$q.screen.lt.md ? 'comfortable' : 'loose')
        }
    }
}
